import React from "react";
import { Route, Switch, Router } from 'react-router-dom';
import history from './configureHistory';
import { render } from "react-dom";
import { GetStartedPPCC }from "../ppcc/confirmation/components/getStarted";

const validateCountry = (document.getElementsByTagName('html')[0].getAttribute('country')).toUpperCase();
const domainCC = window.location.pathname.split("/")[1].toUpperCase();
let countryCode = '';

if (validateCountry === domainCC) {
    countryCode = '/' + validateCountry;
}

let routes = [{ path: countryCode + '/givingfund/ppcc', component: GetStartedPPCC },
    { path: countryCode + '/charities', component: GetStartedPPCC },
    { path: countryCode + '/givingfund/ppcc/getStarted', component: GetStartedPPCC },
    { path: countryCode + '/charities/getStarted', component: GetStartedPPCC }
];
let routeComponents = routes.map(({ path, component }, key) => <Route exact path={path} component={component} key={key} />);
render((
    <Router history={history}>
        <Switch>
            {routeComponents}
        </Switch>
    </Router>
), document.getElementById('givingfundWrapper'));